import SSectionHeader from 'components/framework/SSectionHeader';
import { SError, SNoShows, SProgramSection } from "components/frontpage/cinemaprogram/FrontPageShowsStyles";
import AllCultureShowsLink from 'components/frontpage/culture/AllCultureShowsLink';
import OneCultureShow from 'components/frontpage/culture/OneCultureShow';
import PleaseWait from 'components/loader/PleaseWait';
import { ITheatreProgram } from 'lib/types/Program';
import Settings from 'lib/types/Settings';
import Show, { GroupedShow } from "lib/types/Show";
import styles from "./CultureShowsDisplay.module.css";



//#region [Props]
type CultureShowsDisplayProps = {
    settings: Settings;
    heading?: string;
    isLoading?: boolean;
    isLoadingMore?: boolean;
    isError?: boolean;
    error?: object | unknown;
    data?: ITheatreProgram;
    hideMoreLink?: boolean;
    showDate?: boolean;
    groupShows: boolean;
    showAllShowsFunction?: () => void,
    userOverriddenLinkText?: string;
};
//#endregion

//#region [Component]
export default function CultureShowsDisplay({ settings, heading, isLoading = false, isLoadingMore = false, isError = false, error, data, groupShows, hideMoreLink = false, showDate = false, showAllShowsFunction, userOverriddenLinkText }: CultureShowsDisplayProps) {

    let _shows: Show[] | GroupedShow[] | undefined = data?.shows;
    if (groupShows && _shows) {
        const grouper: Map<string, number> = new Map();
        const groupedShows: GroupedShow[] = [];
        _shows.forEach(show => {
            const _s = grouper.get(show.movieVersionId);
            if (!_s) {
                groupedShows.push({ ...show, totalNumShows: 1 });
                grouper.set(show.movieVersionId, 1);

            } else {
                grouper.set(show.movieVersionId, _s + 1);
            }
        });
        groupedShows.forEach(show => {
            const _s = grouper.get(show.movieVersionId);
            show.totalNumShows = _s!;
        });
        console.debug("GROUPED", groupedShows);
        _shows = groupedShows;
    }



    return <SProgramSection id="kulturprogram">
        {heading && <SSectionHeader className={styles.SHeader}>{heading}</SSectionHeader>}
        {isLoading && <PleaseWait />}
        {!isLoading && <>
            {isError && <SError>Det oppstod en aldri så liten feil...<pre>{JSON.stringify(error)}</pre></SError>}
            {!isError && <>
                <section className={styles.SShowsContainer}>
                    {_shows?.map(show => <OneCultureShow className={styles.SOneCultureShow} key={`${show.movieVersionId}|${show.showStart}`} show={show} article={data!.fwpakkeArticles?.[show.movieVersionId]} />)}
                    {(_shows?.length ?? 0) === 0 && <SNoShows>For øyeblikket ingen forestillinger</SNoShows>}
                </section>

            </>}
            {!hideMoreLink && <AllCultureShowsLink settings={settings} showAllShowsFunction={showAllShowsFunction} userOverriddenLinkText={userOverriddenLinkText} />}
        </>}
        {!isLoading && isLoadingMore && <PleaseWait />}
    </SProgramSection>;
}
//#endregion